<template><div><h1 id="dimensionen-zuordnen" tabindex="-1"><a class="header-anchor" href="#dimensionen-zuordnen"><span>Dimensionen zuordnen</span></a></h1>
<p>Dimensionen zuordnen — Auswahl der Dimensionen für die Mailingauswertung</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In diesem Frame werden die Dimensionen dem unter <RouteLink to="/referenz/refs/ft.refdata.eadimdef.html" title="Dimensionen definieren">Dimensionen definieren</RouteLink> definierten Ereignis zugeordnet und die Parameter definiert.</p>
<p>Pfad: <code v-pre>Personen → Auswertungen → Mailingauswertung → Mailingauswertung</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Pos</dt>
<dd>Positionsnummer</dd>
<dt>Code</dt>
<dd>Code der <a class="link" href="ft.refdata.tbldim.html" title="Dimension">Dimensionen</a>. Die Auswahlliste der Dimensionen ist hardcodiert, kann also durch den Benutzer nicht verändert werden.</dd>
<dt>Beschreibung</dt>
<dd>Bezeichnung der Position (nicht editierbar).</dd>
<dt>Parameter</dt>
<dd>Eingabe der Parameter zur Position gem. <a class="link" href="ft.refdata.tbldim.html" title="Dimension">Dimensionen</a>.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>N/A</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.eamaildef.html" title="Mailingauswertung">Mailingauswertung</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.eadimdef.html" title="Dimensionen definieren">Dimensionen definieren</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.tbldim.html" title="Dimension">Dimensionen</RouteLink></p>
</div></template>


